/** `security` module backend valdiators unique keys */
export enum SecurityBackendValidatorsEnum {
  /** Check that the email for the profile is unique (not occupied by another profile) */
  PROFILE_EMAIL_UNIQUE = 'security/profile::email-unique',
  /** Check that profile with that identifier exists */
  PROFILE_ASSERT_EXISTS_BY_ID = 'security/profile::assert-exists-by-id',
  /** Check that profile with identifier in that DTO exists */
  PROFILE_ASSERT_EXISTS_BY_DTO = 'security/profile::assert-exists-by-dto',
  /** Check that the name for the role is unique (not occupied by another role) */
  ROLE_NAME_UNIQUE = 'security/role::name-unique',
  /** Check that role with that identifier exists */
  ROLE_ASSERT_EXISTS_BY_ID = 'security/role::assert-exists-by-id',
  /** Check that role with identifier in that DTO exists */
  ROLE_ASSERT_EXISTS_BY_DTO = 'security/role::assert-exists-by-dto',
  /** Check that user with that identifier exists */
  USER_ASSERT_EXISTS_BY_ID = 'security/user::assert-exists-by-id',
  /** Check that user with identifier in that DTO exists */
  USER_ASSERT_EXISTS_BY_DTO = 'security/user::assert-exists-by-dto',
  /** Check that user with identifier has bound counterparty */
  USER_HAS_CONTRAGENT_BY_ID = 'security/user::has-contragent-by-id',
  /** Check that user with identifier in that DTO has bound counterparty */
  USER_HAS_CONTRAGENT_BY_DTO = 'security/user::has-contragent-by-dto',
  /** Check that user group(s) with received ID(s) exist(s) */
  USER_GROUP_ASSERT_EXISTS_BY_ID = 'security/user-group-assert-exists-by-id',
  /** Check that user group(s) with ID(s) from received DTO(s) exist(s) */
  USER_GROUP_ASSERT_EXISTS_BY_DTO = 'security/user-group-assert-exists-by-dto',
  /** Check that user with that identifier exists */
  EXTERNAL_USER_ASSERT_EXISTS_BY_ID = 'security/external_user::assert-exists-by-id',
  /** Check that user with identifier in that DTO exists */
  EXTERNAL_USER_ASSERT_EXISTS_BY_DTO = 'security/external_user::assert-exists-by-dto',
}
